import { Helmet } from "react-helmet-async";
import PageShell from "@/components/PageShell";
import Contact from "@/components/Contact";

const ContactPage = () => (
  <PageShell>
    <Helmet>
      <title>Contact | Zentra — Mountain Fresh Farms LLP, Coimbatore</title>
      <meta name="description" content="Everyday Protein. Powered by Microgreens. Zentra protein bars made with horse gram microgreens we grow ourselves. Order online from Coimbatore." />
    </Helmet>
    <Contact />
  </PageShell>
);

export default ContactPage;
